import { render } from "./specimen.vue?vue&type=template&id=5671e5de&scoped=true"
import script from "./specimen.vue?vue&type=script&lang=js"
export * from "./specimen.vue?vue&type=script&lang=js"

import "./specimen.vue?vue&type=style&index=0&id=5671e5de&lang=less&scoped=true"

import exportComponent from "E:\\a工互\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5671e5de"]])

export default __exports__